export const MIN_GAMES_FOR_INSIGHT = 20;
export const MIN_GAMES_RELIABLE = 20;
export const MIN_GAMES_STRONG = 100;

export const getWinrateColor = (winrate) => {
    if (winrate >= 60) return '#10b981';
    if (winrate >= 50) return '#f59e0b';
    return '#ef4444';
};

export const formatWinrate = (winrate) => {
    if (typeof winrate !== 'number') return '0.0';
    return winrate.toFixed(1);
};

export const getLastNWinrate = (matches, n = 10) => {
    if (!matches?.length) return null;
    const sorted = [...matches].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
    const last = sorted.slice(0, n).filter((m) => m.result === 'win' || m.result === 'lose');
    const wins = last.filter((m) => m.result === 'win').length;
    const total = last.length;
    return total > 0 ? { wins, total, winrate: (wins / total) * 100 } : null;
};

export const calculateArchetypeMatchups = (matches, archetypeMap = {}) => {
    const matchups = {};
    (matches || []).forEach((match) => {
        if (!match.myDeckInfo || !match.opponentArchetypeInfo) return;
        const myArchRaw = match.myDeckInfo.archetype;
        const my = typeof myArchRaw === 'object' && myArchRaw?.id ? myArchRaw : (archetypeMap[myArchRaw] || null);
        if (!my) return;
        const opp = match.opponentArchetypeInfo;
        const key = `${my.id}-vs-${opp.id}`;
        if (!matchups[key]) {
            matchups[key] = { myArchetype: my, opponentArchetype: opp, myDeck: match.myDeckInfo, games: 0, wins: 0, losses: 0, playGames: 0, playWins: 0, drawGames: 0, drawWins: 0 };
        }
        const bucket = matchups[key];
        bucket.games++;
        if (match.result === 'win') bucket.wins++;
        else if (match.result === 'lose') bucket.losses++;
        if (match.playDraw === 'play') {
            bucket.playGames++;
            if (match.result === 'win') bucket.playWins++;
        } else if (match.playDraw === 'draw') {
            bucket.drawGames++;
            if (match.result === 'win') bucket.drawWins++;
        }
    });
    Object.values(matchups).forEach((entry) => {
        const total = entry.wins + entry.losses;
        entry.winrate = total > 0 ? (entry.wins / total) * 100 : 0;
        entry.playWinrate = entry.playGames > 0 ? (entry.playWins / entry.playGames) * 100 : 0;
        entry.drawWinrate = entry.drawGames > 0 ? (entry.drawWins / entry.drawGames) * 100 : 0;
    });
    return matchups;
};

export const calculateRollingWinrate = (matches, windowSize = 20) => {
    if (!matches?.length) return [];
    const sorted = [...matches].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
    const output = [];
    for (let i = windowSize - 1; i < sorted.length; i++) {
        const windowMatches = sorted.slice(i - windowSize + 1, i + 1).filter((m) => m.result === 'win' || m.result === 'lose');
        const wins = windowMatches.filter((m) => m.result === 'win').length;
        output.push({ i: i + 1, winrate: windowMatches.length > 0 ? (wins / windowMatches.length) * 100 : 0 });
    }
    return output;
};

export const calculateMonthlyTrends = (matches) => {
    const byMonth = {};
    (matches || []).forEach((match) => {
        const date = new Date(match.timestamp);
        const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
        const name = date.toLocaleDateString('pl-PL', { year: 'numeric', month: 'short' });
        if (!byMonth[key]) byMonth[key] = { key, name, games: 0, wins: 0, losses: 0 };
        byMonth[key].games++;
        if (match.result === 'win') byMonth[key].wins++;
        else if (match.result === 'lose') byMonth[key].losses++;
    });
    return Object.values(byMonth)
        .sort((a, b) => a.key.localeCompare(b.key))
        .map((month) => ({
            ...month,
            winrate: month.wins + month.losses > 0 ? (month.wins / (month.wins + month.losses)) * 100 : 0
        }));
};
